<template>
    <div>
        <div class="logo-wrap">
            <img alt="F&B Logo" src="../../assets/logo.png">
        </div>
        <steps :user="user"/>
    </div>
</template>

<script>
    import Steps from '@/components/Steps/Steps.vue';

    export default {
        name: "register-form",
        components: {Steps},
        props: ['user']
    }
</script>

<style scoped lang="scss">

</style>